export default "__VITE_ASSET__CzfKKDx7__"